export default __webpack_public_path__ + "static/media/9e063e56779cf06d.2904ba9f6462257e3c761061527240e8.svg";